import React from 'react'
import { Concept } from 'models/invoices.models'
import { getFormattedCurrency } from 'lib/helpers/shared.helpers'
import { moneyToText } from 'lib/helpers/utilities'
import { calculateInvoiceTax } from 'lib/utils/Invoices/invoices.utils'
import './style.scss'

interface DisplayTotalDetailsProps {
  concepts: Concept[]
}

interface DisplayTotalProps {
  total: number
  money?: string
  subtotal?: number
}

export const DisplayTotalDetails: React.FC<DisplayTotalDetailsProps> = ({
  concepts,
}) => {
  const subtotal = concepts.reduce((acc, c) => {
    const price = Number(c.price ? c.price : '0')
    const quantity = Number(c.cantidad)
    return Number(acc) + Number(price) * Number(quantity)
  }, 0)

  const discount = concepts.reduce((acc, c) => {
    const discountAmount = Number(c.descuento ?? '0')
    return Number(acc) + Number(discountAmount)
  }, 0)

  const totalTTaxes = concepts.reduce((sum, c) => {
    const price = Number(c.price ?? '0')
    const discount = Number(c.descuento ?? '0')
    const base = price * Number(c.cantidad) - discount

    const taxes = c.impuestos.filter(t => t.tr === 'Traslado')
    const conceptTotalTaxes = taxes.reduce((taxSum, t) => {
      const taxAmount = calculateInvoiceTax(base, t.factor, t.selectedValue)
      return Number(taxSum) + Number(taxAmount)
    }, 0)

    return Number(sum) + Number(conceptTotalTaxes)
  }, 0)

  const totalRTaxes = concepts.reduce((sum, c) => {
    const price = Number(c.price ? c.price : '0')
    const discount = Number(c.descuento ? c.descuento : '0')
    const base = price * Number(c.cantidad) - discount

    const taxes = c.impuestos.filter(t => t.tr === 'Retencion')
    const conceptTotalTaxes = taxes.reduce((taxSum, t) => {
      const taxAmount = calculateInvoiceTax(base, t.factor, t.selectedValue)
      return Number(taxSum) + Number(taxAmount)
    }, 0)

    return Number(sum) + Number(conceptTotalTaxes)
  }, 0)

  const total = subtotal - discount + totalTTaxes - totalRTaxes

  return (
    <div className="component-display-total-details">
      <div className="line">
        <div className="label">Subtotal:</div>
        <div className="value">{getFormattedCurrency(subtotal)}</div>
      </div>
      <div className="line">
        <div className="label">Descuento:</div>
        <div className="value">{getFormattedCurrency(discount)}</div>
      </div>
      <div className="line">
        <div className="label">Total impuestos trasladados:</div>
        <div className="value">{getFormattedCurrency(totalTTaxes)}</div>
      </div>
      <div className="line">
        <div className="label">Total impuestos retenidos:</div>
        <div className="value">{getFormattedCurrency(totalRTaxes)}</div>
      </div>
      <div className="line">
        <div className="label">Total:</div>
        <div className="value">
          <strong>{getFormattedCurrency(total)}</strong>
        </div>
      </div>
    </div>
  )
}

const DisplayTotal: React.FC<DisplayTotalProps> = ({
  total,
  subtotal = 0,
  money = '',
}) => {
  return (
    <div className="component-display-total">
      {Boolean(subtotal) && (
        <div className="line">
          <div className="label">Subtotal:</div>
          <div className="value">{getFormattedCurrency(subtotal)}</div>
        </div>
      )}
      <div className="line">
        <div className="label">{money ? 'Total' : `Total ${money}`}:</div>
        <div className="value secondary">{getFormattedCurrency(total)}</div>
      </div>
      <div className="line">
        <div className="label">{moneyToText(total)}</div>
      </div>
    </div>
  )
}

export default DisplayTotal
